const PROVEEDOR = 'S_SignAPI_E';

const ambits = {
  management: 'unidad',
  profile: 'perfil'
};

const certStatus = {
  ACTIVE: 'Y',
  INACTIVE: 'N'
};

export {
  PROVEEDOR,
  ambits,
  certStatus
};
